// Ürün kartı: masaüstünde görselin üzerinde fare gezdikçe varyant görselleri, kutucuğa gelince o varyantın görseli
(() => {
  const fine = matchMedia('(hover: hover) and (pointer: fine)');
  const preloaded = new WeakSet();
  /* url -> Image; görsel inip çözülene kadar katman açılmaz, alttaki kart görseli kalır (beyaz ekran olmaz) */
  const cache = new Map();

  function imagesOf(card) {
    const el = card && card.querySelector('.gx-cv');
    if (!el) return null;
    if (!el._imgs) {
      try { el._imgs = JSON.parse(el.dataset.imgs || '[]'); } catch { el._imgs = []; }
    }
    return el._imgs;
  }

  function load(src) {
    let entry = cache.get(src);
    if (!entry) {
      const img = new Image();
      entry = { ready: false, waiters: [] };
      cache.set(src, entry);
      const done = () => {
        entry.ready = true;
        entry.waiters.splice(0).forEach((fn) => fn());
      };
      img.onload = () => (img.decode ? img.decode().catch(() => {}) : Promise.resolve()).then(done);
      img.onerror = () => cache.delete(src);
      img.src = src;
    }
    return entry;
  }

  function preload(card) {
    if (!card || preloaded.has(card)) return;
    const imgs = imagesOf(card);
    if (!imgs || !imgs.length) return;
    preloaded.add(card);
    imgs.forEach(load);
  }

  function layerOf(gallery) {
    let l = gallery.querySelector(':scope > .gx-cv-layer');
    if (!l) {
      l = document.createElement('div');
      l.className = 'gx-cv-layer';
      l.setAttribute('aria-hidden', 'true');
      l.innerHTML = '<img alt=""><div class="gx-cv-dots"></div>';
      gallery.appendChild(l);
    }
    return l;
  }

  function paint(gallery, src, index, count) {
    const l = layerOf(gallery);
    const img = l.firstElementChild;
    if (img.getAttribute('src') !== src) img.setAttribute('src', src);
    const dots = l.lastElementChild;
    if (count > 1) {
      if (dots.childElementCount !== count) dots.innerHTML = '<i></i>'.repeat(count);
      [...dots.children].forEach((d, i) => d.classList.toggle('on', i === index));
    } else {
      dots.innerHTML = '';
    }
    l.classList.add('is-on');
  }

  function show(gallery, src, index, count) {
    gallery._gxWant = src;
    const entry = load(src);
    if (entry.ready) {
      paint(gallery, src, index, count);
      return;
    }
    /* Görsel inene kadar ekrandaki görsel (kart ya da önceki varyant) kalır */
    entry.waiters.push(() => {
      if (gallery._gxWant === src) paint(gallery, src, index, count);
    });
  }

  function hide(gallery) {
    if (!gallery) return;
    gallery._gxWant = null;
    const l = gallery.querySelector(':scope > .gx-cv-layer');
    if (l) l.classList.remove('is-on');
  }

  document.addEventListener('pointermove', (e) => {
    if (!fine.matches || e.pointerType !== 'mouse') return;
    const gallery = e.target.closest && e.target.closest('product-card .card-gallery');
    if (!gallery) return;
    const card = gallery.closest('product-card');
    const imgs = imagesOf(card);
    if (!imgs || imgs.length < 2) return;
    preload(card);
    const r = gallery.getBoundingClientRect();
    const index = Math.min(imgs.length - 1, Math.max(0, Math.floor(((e.clientX - r.left) / r.width) * imgs.length)));
    if (gallery._gxWant === imgs[index]) return;
    show(gallery, imgs[index], index, imgs.length);
  }, { passive: true });

  document.addEventListener('pointerover', (e) => {
    if (!fine.matches) return;
    const card = e.target.closest && e.target.closest('product-card');
    /* Fare karta girer girmez varyant görsellerini indirmeye başla */
    if (card) preload(card);
    const item = e.target.closest && e.target.closest('.gx-cv__item');
    if (!item) return;
    const gallery = card && card.querySelector('.card-gallery');
    if (!gallery) return;
    const imgs = imagesOf(card) || [];
    const index = imgs.indexOf(item.dataset.src);
    show(gallery, item.dataset.src, index, index < 0 ? 0 : imgs.length);
  });

  document.addEventListener('pointerout', (e) => {
    const from = e.target.closest && e.target.closest('product-card .card-gallery, .gx-cv');
    if (!from || (e.relatedTarget && from.contains(e.relatedTarget))) return;
    const card = from.closest('product-card');
    hide(card && card.querySelector('.card-gallery'));
  });

  /* Masaüstünde ekrana gelen kartların ilk iki varyant görseli boşta önden insin */
  if (fine.matches && 'IntersectionObserver' in window) {
    const idle = window.requestIdleCallback || ((fn) => setTimeout(fn, 200));
    const io = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        io.unobserve(entry.target);
        const imgs = imagesOf(entry.target);
        if (imgs && imgs.length > 1) idle(() => imgs.slice(0, 2).forEach(load));
      });
    }, { rootMargin: '300px 0px' });
    const watched = new WeakSet();
    const watch = () => document.querySelectorAll('product-card').forEach((card) => {
      if (watched.has(card)) return;
      watched.add(card);
      io.observe(card);
    });
    watch();
    /* Sonsuz listeyle sonradan gelen kartlar */
    let queued = false;
    new MutationObserver(() => {
      if (queued) return;
      queued = true;
      requestAnimationFrame(() => { queued = false; watch(); });
    }).observe(document.body, { childList: true, subtree: true });
  }
})();
